import { IJbpGlobalPartnerData } from 'legacy/lut/features/globalPartner/models/iJbpGlobalPartnerData'

import { IGlobalPartnerManager } from 'clickNgo/models/globalPartner'

import { ISpJbpGlobalPartnerData360 } from '../../../models/iSpJbpGlobalPartnerData360'

export const mapSpToFront = (data: ISpJbpGlobalPartnerData360): IJbpGlobalPartnerData => {
  return {
    entryId: data.EntryId,
    globalPartnerId: data.GlobalPartnerId,
    globalPartnerName: data.GlobalPartnerName,
    countryCodes: data.CountryCodes ? data.CountryCodes.split(',') : [],
    pbm: JSON.parse(data.PBMs).map((el: IGlobalPartnerManager) => el.email),
    partnersCount: data.PartnersCount,
    isGlobalPartnerFullyAcknowledged: data.GlobalPartnerFullyAcknowledged === 1,
    isIts: data.IsIts || 0,
    isReflectOnDashboards: data.IsReflectOnDashboards || 0,
    partnersFullyAcknowledgedCount: data.PartnersFullyAcknowledgedCount,
    globalPartnerCompleteness: data.GlobalPartnerCompleteness,
    partnersCompletedCount: data.PartnersCompletedCount,

    isIncludeOnlyEmeaPartners: Boolean(data.IsIncludeOnlyEmeaPartners),
    globalPartnerCurrentFYearTargetsNet: data.GlobalPartnerCurrentFYearTargetsNet,
    globalPartnerCurrentFYearTargetsTNet: data.GlobalPartnerCurrentFYearTargetsTNet,
    globalPartnerCurrentFYearTargetsUTNet: data.GlobalPartnerCurrentFYearTargetsUTNet,
    globalPartnerCurrentFYearTargetsNdp: data.GlobalPartnerCurrentFYearTargetsNdp,

    partnersCurrentFYearActualsNdp: data.PartnersCurrentFYearActualsNdp,
    partnersCurrentFYearActualsNet: data.PartnersCurrentFYearActualsNet,
    partnersCurrentFYearActualsTNet: data.PartnersCurrentFYearActualsTNet,
    partnersCurrentFYearActualsUTNet: data.PartnersCurrentFYearActualsUTNet,

    partnersCurrentFYearTargetsNdp: data.PartnersCurrentFYearTargetsNdp,
    partnersCurrentFYearTargetsNet: data.PartnersCurrentFYearTargetsNet,
    partnersCurrentFYearTargetsTNet: data.PartnersCurrentFYearTargetsTNet,
    partnersCurrentFYearTargetsUTNet: data.PartnersCurrentFYearTargetsUTNet,

    partnersPrevFYearActualsNdp: data.PartnersPrevFYearActualsNdp,
    partnersPrevFYearActualsNet: data.PartnersPrevFYearActualsNet,
    partnersPrevFYearActualsTNet: data.PartnersPrevFYearActualsTNet,
    partnersPrevFYearActualsUTNet: data.PartnersPrevFYearActualsUTNet,

    actualsToFinPlanNdp: data.ActualsToFinPlanNdp,
    actualsToFinPlanNet: data.ActualsToFinPlanNet,
    actualsToFinPlanTNet: data.ActualsToFinPlanTNet,
    actualsToFinPlanUTNet: data.ActualsToFinPlanUTNet,

    detailedManagersInfo: JSON.parse(data.Managers),
    detailedPBMInfo: JSON.parse(data.PBMs),
    globalPartnerType: data.RTM,
    managers: JSON.parse(data.Managers).map((el: IGlobalPartnerManager) => el.email),
    executiveSummary: data.ExecutiveSummary,
    enabledOfferings: JSON.parse(data.EnabledOfferings || '[]'),
    countOfFullyAcknowledgedPartners: data.CountOfFullyAcknowledgedPartners,
    countOfPartnersWithLess50PercentCompleteness: data.CountOfPartnersWithLess50PercentCompleteness,
    countOfPartnerWithLess100PercentCount: data.CountOfPartnerWithLess100PercentCount,
    countOfPartnersWith100PercentCompleteness: data.CountOfPartnersWith100PercentCompleteness,
    countOfPartnersEmea: data.CountOfPartnersEMEA,
    countOfPartnersAms: data.CountOfPartnersAMS,
    countOfPartnersApj: data.CountOfPartnersAPJ,
    completeness: data.Completeness,
    partnersQuotas: data.PartnersQuotas,
    partnerType: {
      isDistributor: data.IsDistributor === 1,
      isCommercial: data.IsCommercial === 1,
      isRetailer: data.IsRetailer === 1,
    },
    hqPartnerId: data.HQPartnerId,
    eLTGroupUID: data.ELTGroupUID || null,
  }
}
